'use client';
import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiSearch } from 'react-icons/fi';

export type SearchButtonProps = Omit<ButtonProps, 'onClick' | 'className'> & {
  className?: {
    root?: string;
    icon?: string;
  };
};

export function SearchButton(props: SearchButtonProps) {
  const labels = useSystemLabels();
  const isDesktop = useBreakpoint('sm');

  return (
    <SearchDrawer
      trigger={
        <Button
          {...props}
          className={cn('text-foreground', 'ea-search-button', props.className?.root)}
          size={isDesktop ? 'icon' : 'none'}
          variant={isDesktop ? 'outline' : 'none'}
          type="button"
          aria-label={labels('search')}
        >
          <FiSearch className={cn('h-6 w-6', 'ea-search-button__icon', props.className?.icon)} />
        </Button>
      }
    />
  );
}
